import { MY_SETTINGS_PAGE } from 'constants/pages';
import Cog from 'svg/Cog';
import ShieldCheck from 'svg/ShieldCheck';
import Button, { ButtonLink } from 'components/Button';
import classNames from 'styles/utils/classNames';

interface Props {
  isViewerProfile: boolean;
  /** Verified players have nothing left to verify, so the CTA drops out. */
  isVerified: boolean;
  onVerify?: () => void;
  onPinToFavorites?: () => void;
  /** Pinning is the follow edge, so this is "already following". */
  isPinned?: boolean;
  isPinLoading?: boolean;
  className?: string;
}

/** Same pin the Favorites section uses — multicolor, so it ships as an asset. */
const PIN_ICON_SRC = '/images/player-logged-in-v2/pin.svg';

/**
 * The profile's relationship actions: account controls for the owner, the follow
 * edge for everyone else. Extracted from the hero because desktop lifts this block
 * out of the content column and into the sticky rail.
 */
export default function ProfileActions({
  isViewerProfile,
  isVerified,
  onVerify,
  onPinToFavorites,
  isPinned = false,
  isPinLoading = false,
  className,
}: Props) {
  return (
    <div className={classNames('flex flex-col gap-ds-md', className)}>
      {isViewerProfile ? (
        <>
          {!isVerified && onVerify && (
            <Button
              variant="primary"
              size="md"
              onClick={onVerify}
              iconLeft={<ShieldCheck className="size-4" />}
            >
              Verify your profile
            </Button>
          )}
          <ButtonLink
            href={MY_SETTINGS_PAGE}
            variant="secondary"
            size="md"
            iconLeft={<Cog className="size-4" />}
          >
            Profile settings
          </ButtonLink>
        </>
      ) : (
        <Button
          // Pinned reads as a completed state, so it drops to the quieter variant.
          variant={isPinned ? 'secondary' : 'primary'}
          size="md"
          loading={isPinLoading}
          onClick={onPinToFavorites}
          iconLeft={<img src={PIN_ICON_SRC} alt="" className="size-4" />}
        >
          {isPinned ? 'Pinned to Favorites' : 'Pin to Favorites'}
        </Button>
      )}
    </div>
  );
}
